import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// --- Interfaces ---
import type { IClient, IClients } from '@interfaces/client';

export interface IClientsState extends IClients {}

export const INITIAL_STATE: IClientsState = {
	metadata: {
		page: 0,
		pageLimit: 0,
		count: 0,
	},
	result: [],
};

@Injectable({
	providedIn: 'root',
})
export class ClientsStore {
	private _clientsState = new BehaviorSubject<IClientsState>(INITIAL_STATE);
	readonly clientsState$ = this._clientsState.asObservable();

	constructor() {}

	updateClients(clients: IClientsState) {
		const state = this._clientsState.value;

		const data = { ...state, ...clients };

		this._clientsState.next(data);

		return this._clientsState.asObservable();
	}

	updateClient(client: IClient) {
		const state = this._clientsState.value;

		const clientIndex = state.result.findIndex(({ id }) => id === client.id);

		if (clientIndex >= 0)
			state.result[clientIndex] = { ...state.result[clientIndex], ...client };
		else state.result.push(client);

		const data = state;

		this._clientsState.next(data);

		return this._clientsState.asObservable();
	}
}
